import Header from '../components/Header';
import Footer from '../components/Footer';

export default function MerchantAgreement() {
  return (
    <div className="min-h-screen bg-x1493-dark text-white">
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl md:text-4xl font-bold text-x1493-secondary mb-2">商家服務協議</h1>
        <p className="text-white/50 text-sm mb-8">版本 1.0 · 2026-08-16</p>
        <div className="space-y-6 text-white/80 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. 服務範圍與費用</h2>
            <p>
              香港辣谷（HKSpicyValley，下稱「本平台」）為商家提供優惠上架、電子核銷、商家中心數據面板及推廣工具等服務。基本優惠上架服務目前免費；付費增值服務（如流量推廣、顧客聯絡資料開通）以雙方另行確認的訂單及收費為準。除非另有說明，付費服務以月度或單次項目形式提供。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. 優惠審批與上架</h2>
            <p>
              所有商家提交的優惠須經本平台審批後方可上架。本平台有權要求商家修改內容、圖片或細則，並有權拒絕或下架違反法律或平台規則的優惠。商家須保證優惠內容真實、準確、可兌現，並自行承擔優惠所產生的兌換責任（包括名額、有效期及折扣成本）。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. 個人資料處理（重要）</h2>
            <p className="mb-2">就本平台向商家提供的顧客聯絡資料（例如領取優惠顧客的姓名及電話號碼），商家承諾：</p>
            <ul className="list-disc pl-6 space-y-1.5">
              <li>僅將該等資料用於<strong>核銷該項優惠</strong>及（如顧客已明示同意）向該顧客發送該商家自身的優惠資訊；</li>
              <li>未經顧客明示同意，<strong>不會</strong>將該等資料用於任何直接促銷，亦不會出售、出租或轉移予任何第三方；</li>
              <li>尊重顧客的拒收權——顧客表示拒收後立即停止發送推廣訊息並通知本平台；</li>
              <li>於優惠有效期結束後 <strong>90 日內</strong>刪除為核銷目的而持有的顧客聯絡資料（法律另有要求者除外）；</li>
              <li>採取合理的安全措施保護該等資料，防止未經授權的查閱、處理、刪除、遺失或使用；</li>
              <li>遵守香港《個人資料（私隱）條例》（第 486 章）及（如適用）其營業所在地之數據保護法律（包括中國內地《個人信息保護法》）。</li>
            </ul>
            <p className="mt-2">
              商家違反本條款導致顧客投訴、監管機構調查或法律責任的，由商家自行承擔，並賠償本平台因此蒙受的損失。本平台保留暫停或終止服務及扣留相關資料的權利。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. 商家義務</h2>
            <p>
              商家須確保所提供的營業資料（名稱、地址、聯絡方式、營業時間）準確並適時更新；須按優惠細則兌換顧客出示的電子優惠券；核銷驗證碼由商家自行保管，不得外洩。商家中心的登入連結及驗證碼等同商家身分憑證，經商家帳戶進行的操作視為商家本身的操作。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. 智慧財產與品牌使用</h2>
            <p>
              商家授予本平台為推廣其優惠之目的，使用商家提供的商標、圖片及文字的全球性、非獨占、可撤回授權。本平台的名稱、標誌及網站內容歸本平台所有，商家不得未經授權使用。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. 期限與終止</h2>
            <p>
              本協議自商家首次提交優惠並勾選同意時生效，至雙方終止合作為止。任何一方可提前 14 日書面（WhatsApp 或電郵）通知終止。終止後，本平台將下架該商家的優惠，商家須按第 3 條刪除已獲提供的顧客資料。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. 責任限制</h2>
            <p>
              本平台按「現狀」提供服務，不對優惠的兌換效果、銷售成果或第三方（顧客）行為作出保證。在法律允許的範圍內，本平台對商家的累計責任以商家於索償前 12 個月內實際支付的服務費為上限。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. 其他</h2>
            <p>
              本協議受香港法律管轄。本平台可不時修訂本協議並於網站公佈，修訂後繼續使用服務視為接受最新版本。查詢：WhatsApp 852 6232 2466。
            </p>
          </section>

          <p className="text-xs text-white/40 border-t border-white/10 pt-4">
            ※ 本協議範本由平台提供，正式簽署或付費服務開通前，建議雙方各自徵詢法律意見。
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
